import { SVGProps } from 'react'

const SvgNote = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg viewBox='0 0 24 24' className='svg-icon' {...props}>
            <path
                opacity='0.4'
                d='M0.285004 6.27893C0.285004 3.50705 0.285004 2.12111 1.14613 1.26005C2.00719 0.398926 3.39313 0.398926 6.165 0.398926H7.635C10.4068 0.398926 11.7928 0.398926 12.6539 1.26005C13.515 2.12111 13.515 3.50705 13.515 6.27893V9.21893C13.515 11.9907 13.515 13.3767 12.6539 14.2378C11.7928 15.0989 10.4068 15.0989 7.635 15.0989H6.165C3.39313 15.0989 2.00719 15.0989 1.14613 14.2378C0.285004 13.3767 0.285004 11.9907 0.285004 9.21893V6.27893Z'
                fill='#E4E4E7'
                fillOpacity='0.5'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3.40875 7.749C3.40875 7.44457 3.65556 7.19775 3.96 7.19775H9.84C10.1444 7.19775 10.3913 7.44457 10.3913 7.749C10.3913 8.05344 10.1444 8.30025 9.84 8.30025H3.96C3.65556 8.30025 3.40875 8.05344 3.40875 7.749Z'
                fill='#E4E4E7'
                fillOpacity='0.5'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3.40875 4.80906C3.40875 4.50462 3.65556 4.25781 3.96 4.25781H9.84C10.1444 4.25781 10.3913 4.50462 10.3913 4.80906C10.3913 5.1135 10.1444 5.36031 9.84 5.36031H3.96C3.65556 5.36031 3.40875 5.1135 3.40875 4.80906Z'
                fill='#E4E4E7'
                fillOpacity='0.5'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3.40875 10.6889C3.40875 10.3845 3.65556 10.1377 3.96 10.1377H7.635C7.93944 10.1377 8.18625 10.3845 8.18625 10.6889C8.18625 10.9934 7.93944 11.2402 7.635 11.2402H3.96C3.65556 11.2402 3.40875 10.9934 3.40875 10.6889Z'
                fill='#E4E4E7'
                fillOpacity='0.5'
            />
        </svg>
    )
}

export default SvgNote
